import { Component, Input, OnInit, AfterContentInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PatientDrivingLicense } from '../../../../core/models/patient/patientDrivingLicense';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-driver-license-edit',
  templateUrl: './patient-driver-license-edit.component.html',
  styleUrls: ['./patient-driver-license-edit.component.scss']
})
export class PatientDriverLicenseEditComponent implements OnInit {
  @Input() patientId: number;
  @Input() patientDriverLicense: PatientDrivingLicense;
  @Output() patientDriverLicenseChange = new EventEmitter<PatientDrivingLicense>();
  @Output() toggleEvent = new EventEmitter();
  frontImageUrl: any;
  backImageUrl: any;
  userId: number;
  driverLicenseForm = new FormData();
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (res) => {
        this.userId = res.id;
      },
      (error) => { console.error(error); });
    if (!this.patientDriverLicense) {
      this.patientDriverLicense = new PatientDrivingLicense();
    }

    this.frontImageUrl = this.patientDriverLicense.driversLicenseFrontPictureUrl;
    this.backImageUrl = this.patientDriverLicense.driversLicenseBackPictureUrl;
  }

  cancel() {
    this.toggleEvent.emit();
  }

  attachFront(event) {
    this.loaderService.show();
    const file = event.target.files[0];
    this.driverLicenseForm.append('FrontImageSource', file);
    const url = URL.createObjectURL(file);
    this.frontImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.patientDriverLicense.driversLicenseFrontPictureUrl = this.frontImageUrl;
    this.loaderService.hide();
  }

  attachBack(event) {
    this.loaderService.show();
    const file = event.target.files[0];
    this.driverLicenseForm.append('BackImageSource', file);
    const url = URL.createObjectURL(file);
    this.backImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.patientDriverLicense.driversLicenseBackPictureUrl = this.backImageUrl;
    this.loaderService.hide();
  }

  uploadDriverLicense() {
    this.loaderService.show();
    this.driverLicenseForm.append('PatientId', this.patientId.toString());
    this.driverLicenseForm.append('Height', this.patientDriverLicense.height);
    this.driverLicenseForm.append('Weight', this.patientDriverLicense.weight);
    this.driverLicenseForm.append('EyeColor', this.patientDriverLicense.eyeColor);
    this.driverLicenseForm.append('HairColor', this.patientDriverLicense.hairColor);
    this.driverLicenseForm.append('BloodType', this.patientDriverLicense.bloodType);

    this.loaderService.blockWithLoader(this.patientService.updatePatientDrivingLicenseDetails(this.driverLicenseForm)).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.patientService.getCurrentPatientDetails().subscribe(
            (details) => {
              if (details) {
                this.patientDriverLicense.driversLicenseFrontPictureUrl = details.patientDrivingLicenseDetails.driversLicenseFrontPictureUrl;
                this.patientDriverLicense.driversLicenseBackPictureUrl = details.patientDrivingLicenseDetails.driversLicenseBackPictureUrl;
                this.patientDriverLicenseChange.emit(this.patientDriverLicense);

              }
              this.toggleEvent.emit();
            },
            (error) => { console.error(error); },
            () => {
              this.loaderService.hide();
            }
          );
        } else
          console.error(res);
      },
      (error) => {
        console.error(error); 
      }
    );
  }

}
